import React from 'react'
import './style.scss'
import bem from "../../helpers/bem"

const ButtonsWrapper = ({
                          click,
                          children,
                          type,
                        }) => {
  const block = 'button';

  const getButtonMods = () => {
    return {
      [type]: true,
    }
  };

  return (
    <button
      className={bem({block, mods: getButtonMods()})}
      onClick={click}
    >
      {children}
    </button>
  )
};

export default ButtonsWrapper;